export const IconPackMixin = {
  computed: {
    isIconPackPagesFeatureOn() {
      return FONTAWESOME.ICON_PACK_PAGES_ENABLED === 'yes'
    }
  }
}
